/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Faq_Crm_QuestionInputs */

const en_landing_faq_crm_question = /** @type {(inputs: Landing_Faq_Crm_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does Inginuiti integrate with my existing CRM and workflow?`)
};

/**
* | output |
* | --- |
* | "Does Inginuiti integrate with my existing CRM and workflow?" |
*
* @param {Landing_Faq_Crm_QuestionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_faq_crm_question = /** @type {((inputs?: Landing_Faq_Crm_QuestionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Faq_Crm_QuestionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_faq_crm_question(inputs)
});